import { render, staticRenderFns } from "./Recapitulatif.vue?vue&type=template&id=5f750b7f&scoped=true&"
import script from "./Recapitulatif.vue?vue&type=script&lang=js&"
export * from "./Recapitulatif.vue?vue&type=script&lang=js&"
import style0 from "./Recapitulatif.vue?vue&type=style&index=0&id=5f750b7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f750b7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSubheader})
